import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrashPaper: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTrashPaper"><Path d="M7.25 10.9444L6.19444 11.4722L4.83558 10.1134M15.6944 13.5833L18 13.1222M9.88889 17.8056L10.9444 18.8611L13.0556 21.5L16.2222 20.4444L20.4444 16.75L18.3333 13.0556L21.5 8.83333L17.2778 6.72222V4.61111L14.1111 2.5L10.9444 4.61111L4.08333 5.66667L4.61111 9.88889L2.5 10.9444V14.1111L4.08333 15.1667L4.61111 19.3889L7.25 20.9722L10.5 19.1151M13.0556 7.25L11.1718 4.89533" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTrashPaper;
